import React from 'react';

const TarifarioMaritimoContext = React.createContext();

export default TarifarioMaritimoContext;